import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/app/CookiesPolicy.css";
import WhatsAppBanner from "./WhatsAppBanner";
import Nav from "./Nav";

const CookiesPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <WhatsAppBanner />
      <Nav />
      <section className="cookies-section">
        <div className="cookies-container">
          <h1>{t("cookiesPolicy.title")}</h1>

          <h2>{t("cookiesPolicy.whatAreCookies.title")}</h2>
          <p>{t("cookiesPolicy.whatAreCookies.paragraph")}</p>

          <h2>{t("cookiesPolicy.whatCookiesWeUse.title")}</h2>
          <p>{t("cookiesPolicy.whatCookiesWeUse.paragraph")}</p>
          <ul>
            <li>{t("cookiesPolicy.whatCookiesWeUse.list.0")}</li>
            <li>{t("cookiesPolicy.whatCookiesWeUse.list.1")}</li>
            <li>{t("cookiesPolicy.whatCookiesWeUse.list.2")}</li>
            <li>{t("cookiesPolicy.whatCookiesWeUse.list.3")}</li>
          </ul>

          <h2>{t("cookiesPolicy.howToControlCookies.title")}</h2>
          <p>{t("cookiesPolicy.howToControlCookies.paragraph")}</p>

          <h2>{t("cookiesPolicy.policyChanges.title")}</h2>
          <p>{t("cookiesPolicy.policyChanges.paragraph")}</p>
        </div>
      </section>
    </>
  );
};

export default CookiesPolicy;
